var map = {
	"./image_1.jpg": 164,
	"./image_10.jpg": 165,
	"./image_11.jpg": 166,
	"./image_12.jpg": 167,
	"./image_13.jpg": 168,
	"./image_14.jpg": 169,
	"./image_15.jpg": 170,
	"./image_16.jpg": 171,
	"./image_17.jpg": 172,
	"./image_18.jpg": 173,
	"./image_2.jpg": 174,
	"./image_3.jpg": 175,
	"./image_4.jpg": 176,
	"./image_5.jpg": 177,
	"./image_6.jpg": 178,
	"./image_7.jpg": 179,
	"./image_8.jpg": 180,
	"./image_9.jpg": 181,
	"./researcher_placeholder.png": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;